/* import __COLOCATED_TEMPLATE__ from './code.hbs'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { getOwner } from '@ember/application';
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { setInputEnterKeyHint, updateError } from '@square/ember-multipass-components/utils/ember-multipass-input-util';
import { PHONE_DELIVERY_METHODS } from './base';
let TwoFactorUpgradeCodeComponent = (_dec = service('ember-multipassfe-client'), _class = class TwoFactorUpgradeCodeComponent extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor, this);
    _initializerDefineProperty(this, "marketToasts", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _defineProperty(this, "config", void 0);
    _initializerDefineProperty(this, "showCodeError", _descriptor4, this);
    _initializerDefineProperty(this, "validating", _descriptor5, this);
    _initializerDefineProperty(this, "rememberDevice", _descriptor6, this);
    _defineProperty(this, "code", '');
    _defineProperty(this, "codeInput", void 0);
    _defineProperty(this, "phoneDeliveryMethods", PHONE_DELIVERY_METHODS);
    _defineProperty(this, "handleCodeInputDidInsert", element => {
      this.codeInput = element;
    });
    this.config = getOwner(this).resolveRegistration('config:environment');
    this.rememberDevice = this.multipassfeClient.twoFactorDefaults.trustedDeviceOptInDefault;
  }
  get tPrefix() {
    return this.args.tPrefix || '';
  }
  get displayRememberDevice() {
    if (this.args.disableRememberDevice) {
      return false;
    }
    return !this.args.isEmailMethod;
  }
  get codeFieldInvalid() {
    const fieldInvalid = !!(this.showCodeError || this.args.error);
    if (fieldInvalid) {
      updateError(this.codeInput, 'code-error');
    } else {
      updateError(this.codeInput);
    }
    return fieldInvalid;
  }
  get heading() {
    if (this.args.isAccountRecoveryFlow) {
      return this.intl.t(`${this.tPrefix}two_factor.upgrade.recovery.heading`);
    }
    return this.intl.t(`${this.tPrefix}two_factor.upgrade.code.heading`);
  }
  updateCodeError() {
    this.showCodeError = this.code.length < 6;
  }
  checkEnterPressed(event) {
    if (event.key === 'Enter') {
      this.submitDebounced();
    }
  }
  updateCode(event) {
    const currentInput = document.querySelector('.verification-code-input').shadowRoot.activeElement;
    if (!currentInput.hasAttribute('enterKeyHint')) {
      setInputEnterKeyHint(currentInput, 'go');
    }
    this.code = event.detail.code;
    if (this.args.onCodeChange) {
      this.args.onCodeChange(this.code);
    }
    if (this.validating) {
      this.updateCodeError();
    }
  }
  updateRememberDevice(event) {
    this.rememberDevice = event.detail.current;
  }
  submitDebounced() {
    debounce(this, this.submit, 500, true);
  }
  submit() {
    this.validating = true;
    this.updateCodeError();
    if (this.showCodeError) {
      return;
    }
    this.args.submitCode(this.code, this.rememberDevice);
  }
  async handleResendSmsTwoFactorCode() {
    try {
      await this.args.resendSmsTwoFactorCode();
      this.marketToasts.success(this.intl.t(`${this.tPrefix}two_factor.upgrade.generic.code_sent`));
    } catch (e) {
      this.marketToasts.critical(this.intl.t(`${this.tPrefix}two_factor.upgrade.generic.errors.unknown`));
      throw e;
    }
  }
  async handleResendEmailTwoFactorCode() {
    try {
      await this.args.resendEmailTwoFactorCode();
      this.marketToasts.success(this.intl.t(`${this.tPrefix}two_factor.upgrade.generic.code_sent`));
    } catch (e) {
      this.marketToasts.critical(this.intl.t(`${this.tPrefix}two_factor.upgrade.generic.errors.unknown`));
      throw e;
    }
  }
  preventFormSubmit(event) {
    event.preventDefault();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "showCodeError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "validating", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "rememberDevice", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "checkEnterPressed", [action], Object.getOwnPropertyDescriptor(_class.prototype, "checkEnterPressed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateRememberDevice", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateRememberDevice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submitDebounced", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submitDebounced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleResendSmsTwoFactorCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleResendSmsTwoFactorCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleResendEmailTwoFactorCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleResendEmailTwoFactorCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "preventFormSubmit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "preventFormSubmit"), _class.prototype), _class);
export { TwoFactorUpgradeCodeComponent as default };